import UserService from '@/services/UserService'

const createUsersModule = () => ({
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 15,
    filter: '',
    total: 0,
    users: [],
    user: null
  },
  actions: {
    getUserProfile: ({ commit, state }, route) => {
      const { params } = route

      if (params && params.userSlug) {
        const { userSlug } = params
        const [firstName, lastName, id] = userSlug.split('-')

        UserService.getUserProfile(id, firstName, lastName)
          .then((data) => {
            commit('SET_USER', { user: data.user })
          })
          .catch((err) => {
            console.info(err)
          })
      }
    },
    getUsers: ({ commit, state }) => {
      UserService.getUsers(state.pageSize, state.page, state.filter)
        .then((data) => {
          commit('SET_USERS', { users: data.users })
          commit('SET_PAGES', { pages: data.pages })
          commit('SET_TOTAL', { total: data.total })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    setPage: ({ commit, state, dispatch }, page) => {
      commit('SET_PAGE', { page })
      dispatch('getUsers')
    },
    setFilter: ({ dispatch, commit }, filter) => {
      commit('SET_PAGE', { page: 1 })
      commit('SET_FILTER', { filter })
      dispatch('getUsers')
    }
  },
  getters: {
    user: (state) => state.user,
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    }
  },
  mutations: {
    SET_USER: (state, { user }) => {
      state.user = user
    },
    SET_USERS: (state, { users }) => {
      state.users = users
    },
    SET_PAGE: (state, { page }) => {
      state.page = page
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_FILTER: (state, { filter }) => {
      state.filter = filter
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    }
  }
})

export default createUsersModule
